import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import {
  FlexColumn,
  FlexColumnStart,
  FlexRowCenter,
} from "../../../../../../Common/Styles";

type ReportProps = { title: string; description: string };
export const Report = ({ title, description }: ReportProps) => {
  const { typography, Color } = useTheme();
  const textColor = Color.text["text-emphasize-brand-bolder"].value;

  return (
    <ReportContainer $gapInPx={8}>
      <TitleAndDescription $gapInPx={8}>
        <Title $gapInPx={8}>
          <Components.Icon
            type="Info"
            size="16px"
            color={Color.icon["icon-brand-bolder"].value}
          />
          <Components.Text
            style={{ tokenStyle: typography.Heading.S }}
            fontWeight="font-weight-semibold"
            text={title}
            color={textColor}
          />
        </Title>
        <Description $gapInPx={0}>
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            text={description}
            color={textColor}
          />
        </Description>
      </TitleAndDescription>
    </ReportContainer>
  );
};

const ReportContainer = styled(FlexColumn)(
  ({ theme }) => `
  border-radius: ${theme.spacing["spacing-2"].value}rem;
  padding: ${theme.spacing["spacing-4"].value}rem;
  background-color: ${theme.Color.background.brand.subtlest["default-hover"].value};
`
);
const TitleAndDescription = styled(FlexColumnStart)``;
const Description = styled(FlexColumn)``;
const Title = styled(FlexRowCenter)``;
